import { useModelExporter } from '#imports';
import { Color, NearestMipmapLinearFilter, RepeatWrapping, SRGBColorSpace, Vector2 } from 'three';
import { onMounted, ref, watch } from 'vue';

import { KTXLoader } from '@resn/gozer-loading';
import { usePane } from '@resn/gozer-vue';

import { createPackSceneObjectMaterial } from '../../materials/PackSceneObjectMaterial';
import { useBaseObject } from './useBaseObject';

export const useFootball = ({ object }) => {
    const ball = object.getObjectByName('football-inner');

    const normalMap = ball.material.normalMap;
    normalMap.minFilter = NearestMipmapLinearFilter; //LinearMipmapLinearFilter;
    normalMap.needsUpdate = true;

    const material = createPackSceneObjectMaterial({
        roughness: 0.6,
        metalness: 0.2,
        map: ball.material.map,
        normalMap,
        normalScale: new Vector2().setScalar(0.5),
        metalnessMap: normalMap,
    });

    ball.material = material;

    useBaseObject({ object, name: 'Football' });

    onMounted(() => {
        window.football = ball;
        window.footballMaterial = ball.material;
    });

    return {
        ball,
        material,
    };
};
